import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import CmtCard from '../../../@coremat/CmtCard';
import ActivitiesTimeLine from './ActivitiesTimeLine';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CmtList from '../../../@coremat/CmtList';
import { withStyles } from '@material-ui/core/styles';
import PostCell from './PostCell';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect, useSelector } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import { IntlProvider, useIntl } from 'react-intl';
import { injectIntl } from 'react-intl';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import {
  getMyDate5,
  getMyDate1,
  getMyDate2,
  getMyDate4,
  formatPrice,
  myFormatPrice,
  dateDiffInDays,
} from '../../../@jumbo/utils/commonHelper';

const useStyles = theme => ({
  cardRoot: {
    position: 'relative',
  },
  root: {
    flexGrow: 1,
  },
  hotelSelect: {
    width: '100%',
  },
  myTab: {
    marginBottom: theme.typography.pxToRem(16),
  },
  scrollbarRoot: {
    height: '100%',
    marginRight: -24,
    paddingRight: 24,
    marginLeft: -24,
    paddingLeft: 24,
    marginTop: -5,
    paddingTop: 5,
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Activity extends React.Component {
  constructor(props) {
    super(props);
    //  if (props.day=="today")
    var hotels = this.props.auth.authUser.hotels;
    this.state = {
      tabValue: 0,
      errorConnection: false,
      day: this.props.day,
      hotelId: hotels[0].id,
      userActivities: [
        /*  {
          id: 1,
          date: 'July 10, 2020',
          title: 'ios App Launched',
          description: "Chat project's ios app is released today",
          logo: '/images/dashboard/intranet/companyLogo1.svg',
          color: '#5F5F5F',
        },
        {
          id: 2,
          date: 'July 09, 2020',
          title: 'Android App Launched',
          description: "Chat project's Android app is released today",
          logo: '/images/dashboard/intranet/companyLogo2.svg',
          color: '#EE7200',
        },
        {
          id: 3,
          date: 'July 09, 2020',
          title: 'Wieldy Hook version launched',
          description: 'Wieldy Hook version is launched.',
          logo: '/images/dashboard/intranet/companyLogo3.svg',
          color: '#005FEE',
        },
        {
          id: 4,
          date: 'July 08, 2020',
          title: 'Jumbo React design launched',
          description: 'Jumbo React design is ready to be implemented.',
          logo: '/images/dashboard/intranet/companyLogo4.svg',
          color: '#BA57DD',
        },
        {
          id: 5,
          date: 'July 08, 2020',
          title: 'Gest App launched',
          description: "Gest project's ios app is released today",
          logo: '/images/dashboard/intranet/companyLogo1.svg',
          color: '#C03F3F',
        },
        {
          id: 6,
          date: 'July 07, 2020',
          title: 'App Status changed',
          description: 'App status has been changed to launched.',
          logo: '/images/dashboard/intranet/companyLogo2.svg',
          color: '#17A9FC',
        },*/
      ],
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.updateActivities = this.updateActivities.bind(this);
    this.setState({ day: this.props.day });
    //    this.setState({ hotelId: this.props.hotelId });
  }

  updateActivities(mode, tabValue) {
    var cloudUser = this.props.auth.authUser.clouduser;

    const todayDate = new Date();
    const today = todayDate.toISOString().split('T')[0];

    const yesterdayDate = new Date();
    yesterdayDate.setDate(todayDate.getDate() - 1);
    const yesterday = yesterdayDate.toISOString().split('T')[0];

    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tomorrow = tomorrowDate.toISOString().split('T')[0];

    const weekDateDate = new Date();
    weekDateDate.setDate(weekDateDate.getDate() + 7);
    const weekDate = weekDateDate.toISOString().split('T')[0];

    var lookfor1 = today,
      lookfor2 = today;
    if (tabValue == 1) {
      lookfor1 = tomorrow;
      lookfor2 = tomorrow;
    }
    if (tabValue == 2) {
      lookfor2 = weekDate;
    }
    const token = localStorage.getItem('token');
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    var sm = 3;
    if (cloudUser == 0) {
      if (mode == 'arrivals') sm = 3;
      if (mode == 'departures') sm = 4;
      if (mode == 'stay') sm = 5;
    } else {
      if (mode == 'arrivals') sm = 3;
      if (mode == 'departures') sm = 4;
      if (mode == 'stay') sm = 5;
    }
    var hotelId = this.state.hotelId;

    var senddata = {};
    if (cloudUser == 1) {
      var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == hotelId)[0].hotelCode;
      senddata = {
        Action: 'get_reservations',
        token: token,
        Version: 1,
        Data: {
          HotelId: hotelId,
          HotelCode: hotelCode,
          PeriodStart: lookfor1,
          PeriodEnd: lookfor2,
          SearchModel: sm,
        },
      };
    } else {
      senddata = {
        Action: 'get_reservations',
        token: token,
        Version: 1,
        Data: {
          HotelId: hotelId,
          From: lookfor1,
          To: lookfor2,
          searchModel: sm,
        },
      };
    }
    console.log(mode);
    console.log(lookfor1);
    console.log(lookfor2);

    var nationalCurrency = '';
    if (cloudUser == 1)
      nationalCurrency = this.props.auth.authUser.currencies.find(({ national }) => national === true).code;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      const self = this;
      //   const intl = useIntl();
      const data = res.data.Data;
      const myactivities = [];
      if (data != null) {
        this.setState({ errorConnection: false });
        data.forEach(function(item, index) {
          var type = 0;
          if (mode == 'arrivals') {
            if (lookfor1 == lookfor2) {
              if (item['Checkin'] == lookfor1) type = 1;
            } else if (item['Checkin'] >= lookfor1 && item['Checkin'] <= lookfor2) type = 1;
          } else if (mode == 'departures') {
            if (lookfor1 == lookfor2) {
              if (item['Checkout'] == lookfor1) type = 1;
            } else if (item['Checkout'] >= lookfor1 && item['Checkout'] <= lookfor2) type = 1;
          } else if (mode == 'stay') {
            if (item['Status'] == 'checkedin' && cloudUser == 1) type = 1;
            if (item['checkedInStatus'] == '1' && cloudUser == 0) type = 1;
          }

          if (type != 0) {
            var newitem = {};
            newitem.id = index;
            newitem.idres = item['ReservationId'];
            newitem.bookingId = item['ReservationId'];
            if (cloudUser == 1) newitem.bookingId = item['BookingId'];
            //            lookfor == 0 ? (newitem.date = today) : (newitem.date = tomorrow);
            newitem.color = item['Color'];
            var room_number = '',
              room_type = '';
            var roomId = item['RoomId'];
            newitem.roomId = roomId;

            if (Array.isArray(self.props.auth.authUser.rooms))
              self.props.auth.authUser.rooms.forEach(el => {
                if (el.ID == roomId) {
                  room_number = el.Name;
                  room_type = el.Type;
                }
              });
            if (cloudUser == 0) {
              if (cloudUser == 0 && String(roomId).substring(0, 2) == 'rn') {
                roomId = String(roomId).substr(2);
                if (Array.isArray(self.props.auth.authUser.rooms))
                  self.props.auth.authUser.rooms.forEach(el => {
                    if (el.ID == roomId) {
                      room_number = el.Name;
                    }
                  });
              } else if (Array.isArray(self.props.auth.authUser.roomtypes))
                self.props.auth.authUser.roomtypes.forEach(el => {
                  if (el.ID == roomId) {
                    room_number = el.Name;
                  }
                });
            }

            var status = '';
            const { intl } = self.props;
            //            if (type == 1 /*&& item['Status'] != 'checkedin'*/) status = intl.formatMessage({ id: 'status.arriving' });
            //          if (type == 2 /*&& item['Status'] == 'checkedout'*/) status = intl.formatMessage({ id: 'status.leaving' });
            if (item['Status'] == 'checkedin') {
              if (status != '') status = status + ', ';
              status = status + intl.formatMessage({ id: 'status.checkedin' });
            }
            if (item['Status'] == 'checkedout') {
              if (status != '') status = status + ', ';
              status = status + intl.formatMessage({ id: 'status.checkedout' });
            }
            if (item['Status'] == 'arrival') {
              if (status != '') status = status + ', ';
              status = status + intl.formatMessage({ id: 'status.arriving' });
            }
            var persons = 'unknown';
            if (item['Text'].substr(0, 1) == '(') persons = item['Text'].substr(1, item['Text'].indexOf(')') - 1);

            if ([10, 11, 12, 16].includes(self.props.auth.authUser.role)) {
              newitem.room_number = room_number;
              newitem.hid = hotelId;
              var baseres = item['Text'];
              if (item['Text'].substr(0, 1) == '(') {
                persons = baseres.substr(1, baseres.indexOf(')') - 1);
                baseres = baseres.slice(baseres.indexOf(')') + 1);
              }
              if (cloudUser == 1) persons = item['Adults'] + ' + ' + item['Children'];

              if (item['Text'].substr(0, 1) == '(') persons = item['Text'].substr(1, item['Text'].indexOf(')') - 1);
              if (baseres.indexOf('(') > 0) baseres = baseres.slice(0, baseres.indexOf('(') - 1);

              newitem.title = baseres;
              // intl.formatMessage({ id: 'room' }) + ' ' + room_number + ': ' +
              newitem.description = '';
              if (room_number != '') newitem.description += intl.formatMessage({ id: 'room' }) + ' ' + room_number + ', ';
              if (cloudUser == 0) {
                newitem.bId = item['BookingId'];
                newitem.checkedInStatus = item['checkedInStatus'];
              }
              if (cloudUser == 1) {
                newitem.bId = item['BookingId'];
                if (newitem.bId == null) newitem.bId = 'Walk-in';
              }

              if (item['source'] != undefined && item['source'] != '') {
                newitem.source = item['sourcename'];
                newitem.sourceicon = item['sourceicon'];
                newitem.sourcecolor = item['Color'];
                newitem.sourceFontColor = item['fontColor'];
              }
              var nights = 0;
              const date1 = new Date(item['Checkin']);
              const date2 = new Date(item['Checkout']);
              const diffTime = Math.abs(date2 - date1);
              nights = dateDiffInDays(date1, date2); //Math.ceil(diffTime / (1000 * 60 * 60 * 24));

              newitem.description +=
                intl.formatMessage({ id: 'bookings.stay' }) +
                ' ' +
                getMyDate2(item['Checkin'], self.props.auth.authUser.language) +
                ' - ' +
                getMyDate2(item['Checkout'], self.props.auth.authUser.language) +
                ', ' +
                nights +
                ' ' +
                intl.formatMessage({ id: 'bookings.nights' }) +
                '<br/><br/>';

              if (status != '')
                newitem.description += status + ', ' + intl.formatMessage({ id: 'bookings.persons' }) + persons;
              else newitem.description += intl.formatMessage({ id: 'bookings.persons' }) + persons;
              newitem.checkin = getMyDate5(item['Checkin'], self.props.auth.authUser.language);
              newitem.checkout = getMyDate5(item['Checkout'], self.props.auth.authUser.language);
              newitem.nights = nights + ' ' + intl.formatMessage({ id: 'bookings.nights' });

              if (cloudUser == 1) {
                newitem.adults = item['Adults'];
                newitem.children = item['Children'];
                newitem.roomname = room_type; //+ ' / ' + room_number;
                newitem.price = '';

                if (item['TotalPrice'] != '')
                  newitem.price += formatPrice(item['TotalPrice'], 'hr') + ' ' + nationalCurrency;
                if (item['TotalPriceCurr'] != '' && nationalCurrency != item['Currency']) {
                  if (newitem.price != '') newitem.price += ', ';
                  newitem.price += formatPrice(item['TotalPriceCurr'], 'hr') + ' ' + item['Currency'];
                }
                newitem.hotelname = self.props.auth.authUser.hotels.find(({ id }) => id === self.state.hotelId).name;
              } else {
                var nights = 0;
                const date1 = new Date(item['Checkin']);
                const date2 = new Date(item['Checkout']);
                const diffTime = Math.abs(date2 - date1);
                nights = dateDiffInDays(date1, date2); //Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                newitem.description +=
                  intl.formatMessage({ id: 'bookings.stay' }) +
                  ' ' +
                  getMyDate2(item['Checkin'], self.props.auth.authUser.language) +
                  ' - ' +
                  getMyDate2(item['Checkout'], self.props.auth.authUser.language) +
                  ', ' +
                  nights +
                  ' ' +
                  intl.formatMessage({ id: 'bookings.nights' }) +
                  '<br/><br/>';

                if (status != '')
                  newitem.description += status + ', ' + intl.formatMessage({ id: 'bookings.persons' }) + persons;
                else newitem.description += intl.formatMessage({ id: 'bookings.persons' }) + persons;

                newitem.adults = item['adults'];
                newitem.children = item['children'];

                /*newitem.adults = persons;
                newitem.children = '';*/
                newitem.roomname = room_number;
                newitem.hotel_id = item['HotelId'];
                newitem.hotelname = self.props.auth.authUser.hotels.find(({ id }) => id === newitem.hotel_id).name;

                newitem.price = myFormatPrice(item['Price'], self.props.auth.authUser.numberMode) + ' ' + item['Currency'];
                newitem.balance =
                  myFormatPrice(item['Balance'], self.props.auth.authUser.numberMode) + ' ' + item['Currency'];
                newitem.allFolios = item['AllFolios'];
                newitem.openFolios = item['OpenFolios'];
              }
              if (cloudUser == 1 && self.props.auth.authUser.features == 4) {
                newitem.title = intl.formatMessage({ id: 'room' }) + ' ' + room_number;
              }

              newitem.status = status;
              /*if (type == 1)*/
              /*if (type == 2) newitem.color = '#D13438';*/
            }
            if (self.props.auth.authUser.role == 5) {
              var nights = 0;
              const date1 = new Date(item['Checkin']);
              const date2 = new Date(item['Checkout']);
              const diffTime = Math.abs(date2 - date1);
              nights = dateDiffInDays(date1, date2); //Math.ceil(diffTime / (1000 * 60 * 60 * 24));

              newitem.description +=
                intl.formatMessage({ id: 'bookings.stay' }) +
                ' ' +
                getMyDate2(item['Checkin'], self.props.auth.authUser.language) +
                ' - ' +
                getMyDate2(item['Checkout'], self.props.auth.authUser.language) +
                ', ' +
                nights +
                ' ' +
                intl.formatMessage({ id: 'bookings.nights' }) +
                '<br/><br/>';

              if (status != '')
                newitem.description += status + ', ' + intl.formatMessage({ id: 'bookings.persons' }) + persons;
              else newitem.description += intl.formatMessage({ id: 'bookings.persons' }) + persons;

              newitem.room_number = room_number;
              newitem.title = intl.formatMessage({ id: 'room' }) + ' ' + room_number;
              newitem.description = status + ', ' + intl.formatMessage({ id: 'res.persons' }) + persons;
              newitem.status = status;
              newitem.adults = item['adults'];
              newitem.children = item['children'];

              newitem.roomname = room_number;
              newitem.hotel_id = item['HotelId'];
              newitem.hotelname = self.props.auth.authUser.hotels.find(({ id }) => id === newitem.hotel_id).name;
              newitem.checkin = getMyDate5(item['Checkin'], self.props.auth.authUser.language);
              newitem.checkout = getMyDate5(item['Checkout'], self.props.auth.authUser.language);
              newitem.nights = nights + ' ' + intl.formatMessage({ id: 'bookings.nights' });

              //              newitem.description = 'Room ID: ' + item['RoomId'];
              /*if (type == 2) newitem.color = '#D13438';*/
            }
            myactivities.push(newitem);
          }
          /*
          item['resource'] = item['RoomId'];
          item['start'] = item['Checkin'] + 'T12:00:00';
          item['end'] = item['Checkout'] + 'T12:00:00';
          item['id'] = item['ReservationId'];
          item['text'] = item['Text'];
          item['source'] = item['source'];
          item['backColor'] = item['Color'];*/
        });
        myactivities.sort(function(a, b) {
          if (a.room_number < b.room_number) return -1;
          if (a.room_number > b.room_number) return 1;
          return 0;
        });
        if (tabValue == 1) this.setState({ userActivities: myactivities, x2: myactivities.length, x1: null, x3: null });
        else if (tabValue == 2) this.setState({ userActivities: myactivities, x3: myactivities.length, x1: null, x2: null });
        else this.setState({ userActivities: myactivities, x1: myactivities.length, x2: null, x3: null });
      } else this.setState({ errorConnection: true });
    });
  }

  handleTabChange(event, newValue) {
    this.setState({ tabValue: newValue });
    this.updateActivities(this.props.day, newValue);
  }

  handleCustomChange(event, owner) {
    this.setState({ [owner]: event.target.value }, () => {
      this.updateActivities(this.props.day);
    });
  }

  componentDidMount() {
    const { currentApplication, setCurrentApplication } = this.context;
    setCurrentApplication(0);

    this.updateActivities(this.props.day);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.day !== this.props.day) {
      this.setState({ tabValue: 0, day: this.props.day, x1: null, x2: null, x3: null }, () => {
        this.updateActivities(this.props.day);
      });
    }
  }

  render() {
    const { classes } = this.props;
    var actionTitle = '';
    var hotels = this.props.auth.authUser.hotels;
    const myDate = new Date();
    const { intl } = this.props;
    if (this.state.day == 'arrivals') {
      actionTitle = intl.formatMessage({ id: 'pages.arrivals' });
    }
    if (this.state.day == 'departures') {
      actionTitle = intl.formatMessage({ id: 'pages.departures' });
    }
    if (this.state.day == 'stay') {
      actionTitle = intl.formatMessage({ id: 'pages.stay' });
    }
    const { currentPage, setCurrentPage } = this.context;

    setCurrentPage(actionTitle);
    var title1 = intl.formatMessage({ id: 'tabs.today' });
    if (this.state.x1 != null) title1 += ' (' + this.state.x1 + ')';
    var title2 = intl.formatMessage({ id: 'tabs.tomorrow' });
    if (this.state.x2 != null) title2 += ' (' + this.state.x2 + ')';
    var title3 = intl.formatMessage({ id: 'tabs.week' });
    if (this.state.x3 != null) title3 += ' (' + this.state.x3 + ')';

    var dateDisplay = getMyDate2(myDate.toISOString().split('T')[0], this.props.auth.authUser.language);
    return (
      <PageContainer>
        {this.state.errorConnection && (
          <Alert severity="error">
            <IntlMessages id={'error.connection'} />
          </Alert>
        )}
        {hotels.length > 1 && (
          <FormControl variant="filled" className={classes.hotelSelect}>
            <InputLabel id="hotel-label">Hotel</InputLabel>
            <Select
              labelId="hotel-label"
              id="hotelid"
              fullWidth
              className={classes.hotelSelect}
              name="hotelid"
              value={this.state.hotelId}
              onChange={event => this.handleCustomChange(event, 'hotelId')}>
              {hotels.map((t, idx) => (
                <MenuItem value={t.id}>{t.name}</MenuItem>
              ))}
              {this.props.auth.authUser.clouduser == 0 && (
                <MenuItem value="0">
                  <IntlMessages id="invoices.allProperties" />
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}

        {this.props.day != 'stay' && (
          <Tabs
            value={this.state.tabValue}
            className={classes.myTab}
            onChange={(event, newValue) => this.handleTabChange(event, newValue)}
            indicatorColor="primary"
            textColor="primary"
            centered>
            <Tab label={title1} />
            <Tab label={title2} />
            <Tab label={title3} />
          </Tabs>
        )}

        {this.props.auth.authUser.clouduser == 0 && <CmtCardHeader title={actionTitle} subTitle="" />}
        <PerfectScrollbar className={classes.scrollbarRoot}>
          <ActivitiesTimeLine showDetails="false" data={this.state.userActivities} />
        </PerfectScrollbar>
      </PageContainer>
    );
  }
}

Activity.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

Activity.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(Activity)));
